import { IMessage } from "@stomp/rx-stomp";

export type WebsocketMessage = IMessage;

export enum WebsocketConnectionStatus {
    Connected = "Connected",
    Disconnected = "Disconnected",
    Connecting = "Connecting",
    Disconnecting = "Disconnecting",
}

export interface WebsocketConnectionEndpointStatus {
    endpoint: string;
    status: WebsocketConnectionStatus;
}
